module.exports = __webpack_public_path__ + "static/img/5areaA_9.808ed0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/5areaA_9.png
// module id = 1045
// module chunks = 1